import { EntryTypeBlockData, EntryTypeBlockStatus } from 'chaika-frontend-types/frontend-cms';

export function collectActiveBlocks(blocks: EntryTypeBlockData[]): EntryTypeBlockData[] {
    const lastVersionById = new Map<string, EntryTypeBlockData>();

    blocks
        .filter(block => block.status === EntryTypeBlockStatus.Active)
        .forEach(block => lastVersionById.set(block.id, block));

    return Array.from(lastVersionById.values());
}
